import { AppHeaderLogo, IconLibrary } from '@act/storybook';
import { useSideMenuDrawer } from '@act/utilities/SideMenuDrawerContext';
import { Box, Drawer, IconButton, useTheme } from '@mui/material';
import { EXPANDED_GRID_WIDTH } from '../app/constants';

interface SideMenuDrawerProps {
  sideMenuContent: React.ReactElement;
}

const SideMenuDrawer = ({ sideMenuContent }: SideMenuDrawerProps) => {
  const { isDrawerOpen, closeDrawer } = useSideMenuDrawer();
  const theme = useTheme();

  return (
    <Drawer
      anchor="left"
      open={isDrawerOpen}
      onClose={closeDrawer}
      sx={{
        zIndex: theme => theme.zIndex.modal + 1,
        '& .MuiDrawer-paper': {
          width: EXPANDED_GRID_WIDTH,
          boxSizing: 'border-box',
          overflowX: 'hidden',
          overflowY: 'auto',
        },
      }}
    >
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflowX: 'hidden',
          overflowY: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderRight: `1px solid ${theme.palette.strokePrimary}`,
            borderBottom: `1px solid ${theme.palette.strokePrimary}`,
            minHeight: '90px',
            padding: '0 16px',
          }}
        >
          <AppHeaderLogo />
          <IconButton onClick={closeDrawer}>
            <IconLibrary iconName="X" weight="regular" size={24} />
          </IconButton>
        </Box>

        {sideMenuContent && (
          <Box
            sx={{
              flex: 1,
              overflow: 'auto',
              minHeight: 0,
              padding: '8px',
              borderRight: `1px solid ${theme.palette.strokePrimary}`,
            }}
          >
            {sideMenuContent}
          </Box>
        )}
      </Box>
    </Drawer>
  );
};

export default SideMenuDrawer;
